import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-information-management",
  "use": "icon-information-management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-information-management\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 128H128a64 64 0 0 0-64 64v672a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64z m0 64v117.664l-377.44 255.296L128 300.768V192h768zM128 864V378.048l372.64 252.032a31.968 31.968 0 0 0 35.84 0L896 386.912V864H128z\" p-id=\"4158\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol